import { COLORS } from "@coeff/utils";
import React from "react";
import styled from "styled-components";

const StyledLink = styled.span<{ $display: "inline" | "block"; $fontWeight?: string }>`
  display: ${props => props.$display};
  font-size: 14px;
  color: ${COLORS.coeblue4};
  cursor: pointer;
  ${props => (props.$fontWeight ? `font-weight: ${props.$fontWeight};` : "")};
`;

type PPressLinkProps = {
  handleClick: () => void;
  label: string;
  name?: string;
  inline?: boolean;
  fontWeight?: string;
};

export const Link = ({ label, handleClick, inline, name, fontWeight }: PPressLinkProps) => (
  <StyledLink
    data-test-id={`ppress-link-${name}`}
    onClick={() => handleClick?.()}
    $display={inline ? "inline" : "block"}
    $fontWeight={fontWeight}
  >
    {label}
  </StyledLink>
);
